import { AVATAR_SIZE, OPTIONS_SIZE } from './constants';

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - AVATAR_SIZE - OPTIONS_SIZE) * percent;
};

export const getColumns = ({ totalWidth }: { totalWidth?: number }) => [
  {
    accessorKey: 'avatar',
    size: AVATAR_SIZE,
    isAvatar: true,
  },
  {
    accessorKey: 'name',
    header: 'Name',
    minSize: 62,
    sx: { pl: 0 },
    size: getColumnSize(0.5, totalWidth),
    enableResizing: true,
  },
  {
    accessorKey: 'invitedBy',
    header: 'Invited by',
    size: getColumnSize(0.5, totalWidth),
    minSize: 86,
  },
  {
    accessorKey: 'gap',
    size: 0,
  },
  {
    accessorKey: 'options',
    size: OPTIONS_SIZE,
    isOptions: true,
  },
];
